import React, { useCallback, useRef } from 'react'
import { useMemo } from 'react'
import { qualificheColumns } from './columns/_columns'
import { Role } from '../core/_models'
import GenericTable, {
  GenericTableHandle
} from '../../../../../components/GenericTable'
import {
  PaginatedResponse,
  PaginationMeta
} from '../../../../../interfaces/PaginatedResponse'
import { list } from '../../../../../lib/fetch/roles'
import { useAuth } from '../../../../../context/Auth'

const QualificheTable = () => {
  const ref = useRef<GenericTableHandle>(null)
  const refetch = useCallback(() => {
    ref.current?.refetch()
  }, [ref])
  const columns = useMemo(() => qualificheColumns(refetch), [refetch])
  const [{ token }] = useAuth()
  const fetch = useCallback(
    async (
      paginationMeta: PaginationMeta
    ): Promise<PaginatedResponse<Role> | string> => {
      let result
      try {
        result = await list({
          token
        })
      } catch (error) {
        let message = 'Error'
        if (error instanceof Error) {
          message = error.message
        }
        result = message
      }
      return result
    },
    [token]
  )
  return <GenericTable columns={columns} onFetch={fetch} ref={ref} />
}

export { QualificheTable }
